import api from "../utils/axios";

const UserService = {
  updateProfile: async (userId, payload) => {
    const response = await api.patch(
      `/users/${userId}`,
      payload
    );

    return response.data;
  },
};

export default UserService;